<script>
  import { selectedGroups } from '../../store'
  import { createEventDispatcher } from 'svelte'
  import FiltersView from './FiltersView.svelte'

  export let showFilters = false
  export let filters = {}
  export let origin = []
  export let filtered = [...origin]

  const dispatch = createEventDispatcher()

  let i = 0

  let dates = {}
  let _filters = null

  $: applyFilters(filters, origin.length)

  function applyFilters (filters) {
    // console.log('[DEBUG] apply filters', filters['su_erp_proj'])
    if (origin.length === 0) {
      return
    }
    if (_filters == null) {
      _filters = JSON.stringify(filters)
      // console.log('[DEBUG] _filters is empty', )
    } else if (JSON.stringify(filters) === _filters) {
      // console.log('[DEBUG] filters are the same')
      return
    }
    // console.log('[DEBUG] filters are not the same')
    _filters = JSON.stringify(filters)
    const valuedFilters = {}
    Object.keys(filters).forEach(fk => {
      if (filters[fk].value === ''
        || filters[fk].range_list && filters[fk].min_value + filters[fk].max_value === '') {
        // console.log('[DEBUG] ' + fk + ' value is empty', )
        return
      }
      // console.log('[DEBUG] ' + fk, JSON.stringify(filters[fk])  )

      if (typeof filters[fk].value === 'string') {
        filters[fk].value = filters[fk].value.toLowerCase()
      } else if (Array.isArray(filters[fk].value)) {
        filters[fk].value = filters[fk].value.map(p => p.toLowerCase())
      }

      valuedFilters[fk] = filters[fk]
    })
    // console.log('[DEBUG] applyFilters(): valuedFilters', JSON.stringify(valuedFilters))
    filtered = [...origin.filter(l => matchFieldFilters(l, valuedFilters))]
    // console.log('[DEBUG] filtered len:', filtered.length)
  }

  function matchFieldFilters (item, filters) {
    // console.log('[DEBUG] matchFieldFilters')
    let result = true
    let filter
    Object.keys(filters).forEach(fk => {
      filter = filters[fk]
      if ((filter.type === 'number' && filter.value > 0 || filter.value && filter.value.length > 0)
        || filter.min_value && filter.min_value.length > 0
        || filter.max_value && filter.max_value.length > 0) {
        result = result
          && item[filter.key] != null
          && ((filter.type === 'number') || item[filter.key].length > 0)
          && compFilter(item[filter.key], filter)
      }
    })
    return result
  }

  function compFilter (itemFieldValue, filter) {
    // i += 1
    // if (i < 3) console.log('[DEBUG] filter:', itemFieldValue, filter)

    const isNumber = filter['type'] === 'number'
    const isArray = Array.isArray(filter.value)
    // if (i < 3) console.log('[DEBUG] isArray', isArray)

    //if (filter.key === 'AssetValue') {
    //  console.log('[DEBUG] itemFieldValue', itemFieldValue)
    //}
    let filterValue = ''
    try {
      filterValue = isNumber ? parseInt(filter.value, 10) : filter.value
    } catch {
      // nop
    }

    itemFieldValue = isNumber ? itemFieldValue : itemFieldValue.toLowerCase()

    if (filter.spec === 'min') {
      return itemFieldValue >= filterValue
    }
    if (filter.spec === 'max') {
      return itemFieldValue <= filterValue
    }
    if (filter.range_list) {
      let values = itemFieldValue.split(';')
      for (let i = 0; i < values.length; i++) {
        // console.log('[DEBUG]', values[i])
        if (values[i] === '') {
          continue
        }
        if ((values[i] >= filter.min_value.toLowerCase() || filter.min_value.length === 0)
          && (values[i] <= filter.max_value.toLowerCase() || filter.max_value.length === 0)) {
          return true
        }
      }
      return false
    }

    if (isNumber) return itemFieldValue === filterValue

    if (isArray) return filter.value.some(f => itemFieldValue.indexOf(f) > -1)

    // default
    return itemFieldValue.indexOf(filterValue) > -1
  }

  function clearFilters () {
    $selectedGroups = {}
    Object.keys(filters).forEach(fk => {
      clearFieldHandler(fk)
    })
  }

  function clearFieldHandler (fk) {
    if (filters[fk].hasOwnProperty('value')) {
      filters[fk].value = ''
    }
    if (filters[fk].range_list) {
      filters[fk].min_value = ''
      filters[fk].max_value = ''
    }
    if (dates.hasOwnProperty(fk)) {
      dates[fk] = ''
    }
    if (filters[fk].hasOwnProperty('select')) {
      filters[fk].select = []
    }
  }

</script>

<div>
  {#if showFilters}
    <FiltersView {origin} bind:filters={filters} {showFilters}
                 on:clear={() => clearFilters() }
                 on:close={() => dispatch('close')}
    />
  {/if}
</div>
